interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({
  page,
  totalPages,
  onChange,
}: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  const baseBtn =
    "w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-lg text-sm transition-colors cursor-pointer whitespace-nowrap";

  return (
    <div className="flex items-center justify-center gap-2 mt-8">
      <button
        type="button"
        disabled={page === 1}
        onClick={() => onChange(page - 1)}
        className={`${baseBtn} border border-background-200 text-foreground-600 hover:border-primary-300 hover:text-primary-600 disabled:opacity-40 disabled:cursor-not-allowed`}
      >
        <i className="ri-arrow-left-s-line text-lg" />
      </button>

      {pages.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onChange(p)}
          className={`${baseBtn} ${
            p === page
              ? "bg-primary-500 text-background-50 font-semibold"
              : "border border-background-200 text-foreground-600 hover:border-primary-300 hover:text-primary-600"
          }`}
        >
          {p}
        </button>
      ))}

      <button
        type="button"
        disabled={page === totalPages}
        onClick={() => onChange(page + 1)}
        className={`${baseBtn} border border-background-200 text-foreground-600 hover:border-primary-300 hover:text-primary-600 disabled:opacity-40 disabled:cursor-not-allowed`}
      >
        <i className="ri-arrow-right-s-line text-lg" />
      </button>
    </div>
  );
}